export const width = window.innerWidth;

export const systemTheme = (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
